import { useState, useEffect } from 'react';
import { Modal, Spin } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';
import { TinyMCEMDInput, TextInput } from '@wajeez-web/components/ui';
import {
  useCreateNarratorMultilingual,
  useEditNarratorMultilingual,
  useGetNarratorByIdMultilingual,
} from '@wajeez-web/components/helpers';
import { WajeezMultilingualFormBuilder } from '@wajeez-web/components/form-builder';
import {
  clearNarratorByIdMultilingual,
  createNarratorMultilingual,
  editNarratorMultilingual,
  getNarratorByIdMultilingual,
} from '@wajeez-web/stores/content';
import { Languages } from '@wajeez-web/core/utils';

export interface NarratorModalProps
  extends CommonModalProps<Server.CreateNarratorV2Input> {
  id?: number;
}

type Input = {
  name: string;
  about: string;
};

const NarratorssModal = ({
  isOpen,
  onClose,
  onSubmit,
  id,
}: NarratorModalProps) => {
  const { status: createNarratorMultilingualStatus } =
    useCreateNarratorMultilingual();
  const { status: editNarratorMultilingualStatus } =
    useEditNarratorMultilingual();

  const { status, data } = useGetNarratorByIdMultilingual();

  useEffect(() => {
    if (id) {
      getNarratorByIdMultilingual(id);
    }

    return () => {
      clearNarratorByIdMultilingual();
    };
  }, [id]);

  return (
    <Modal
      title={'Narrator'}
      open={isOpen}
      onClose={onClose}
      alertTarget="modal"
      fontClassName="font-[Tajawal]"
      handleAlert
    >
      {status === 'loading' ? (
        <div className="h-[400px] flex justify-center items-center">
          <Spin />
        </div>
      ) : (
        <div className="pb-14 overflow-y-auto">
          <WajeezMultilingualFormBuilder<Server.CreateNarratorV2Input>
            rows={{}}
            profileRows={{
              name: {
                fieldType: Server.FieldType.Text,
                fieldOptions: {},
                label: 'Name',
                placeHolder: 'Name',
                required: true,
              },
              about: {
                fieldType: Server.FieldType.AreaText,
                fieldOptions: {},
                label: 'About',
                placeHolder: 'About',
                required: false,
              },
            }}
            onSubmit={(data) => {
              if (!id) {
                createNarratorMultilingual(data, onSubmit);
              } else {
                editNarratorMultilingual(
                  {
                    id,
                    ...data,
                  },
                  onSubmit
                );
              }
            }}
            onCancel={onClose}
            isUpdate={
              createNarratorMultilingualStatus === 'loading' ||
              editNarratorMultilingualStatus === 'loading'
            }
            formValues={
              data || {
                profiles: [
                  {
                    languageId: Languages.AR,
                  },
                ],
              }
            }
          />
        </div>
      )}
    </Modal>
  );
};

export default NarratorssModal;
